"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventQueueHandler = void 0;
var EventQueueHandler = /** @class */ (function () {
    function EventQueueHandler(logger, eventQueue) {
        var _this = this;
        this.isDequeueing = false;
        this.queueName = '';
        this.dequeMessageHandler = function (event) {
            var _a = event.data, type = _a.type, message = _a.message;
            if (type !== _this.queueName)
                return;
            if (message === 'networkDown') {
                _this.logEvent();
            }
            if (message === 'success') {
                _this.eventQueue.remove();
                if (!_this.eventQueue.hasNext()) {
                    _this.isDequeueing = false;
                    return;
                }
                _this.logEvent();
            }
            if (message === 'startDequeue') {
                if (!_this.isDequeueing) {
                    _this.isDequeueing = true;
                    _this.logEvent();
                }
            }
        };
        this.logEvent = function () {
            var sendable = _this.eventQueue.next();
            if (sendable) {
                _this.logger.log(sendable);
            }
        };
        this.startDequeueing = function () {
            if (_this.eventQueue.hasNext())
                postMessage({ type: _this.queueName, message: 'startDequeue' }, '*');
        };
        this.logger = logger;
        this.eventQueue = eventQueue;
        this.queueName = EventQueueHandler.TAG + EventQueueHandler.queueId;
        EventQueueHandler.queueId += 1;
        logger.setQueueName(this.queueName);
        addEventListener('message', this.dequeMessageHandler);
    }
    EventQueueHandler.TAG = 'TWALEventQueueHandler';
    EventQueueHandler.queueId = 0;
    return EventQueueHandler;
}());
exports.EventQueueHandler = EventQueueHandler;
